import React from 'react';

import {MaxWidthContainer} from '../../components/Layout';
import WelcomePwaContent from './components/WelcomePwaContent';
import WelcomePwaMedia from './components/WelcomePwaMedia';

const WelcomePwaPage = () => {
    return (
        <div className='flex w-full flex-col items-center lg:min-h-[568px] lg:flex-row-reverse lg:justify-center'>
            <WelcomePwaMedia />
            <MaxWidthContainer className='lg:max-w-[50%] lg:flex-shrink-0'>
                <WelcomePwaContent />
            </MaxWidthContainer>
        </div>
    );
};

export default WelcomePwaPage;
